export default __webpack_public_path__ + "media/allyVid.677932ad.mp4";